import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { LoadingModule } from '@coin/shared/core/data-access';
import { HighlightPipe } from '@coin/shared/group-search/util';
import { ClickedOutsideDirective } from '@coin/shared/core/util-directives';
import { IconButtonComponent, V2ButtonComponent, V2TextInputComponent } from '@coin/shared/core/ui-storybook';
import { GroupSearchResultsComponent } from './components/search-results/group-search-results.component';
import { GroupSearchBarComponent } from './components/search-bar/group-search-bar.component';
import { FeatureFlagDirective } from '@coin/shared/core/feature-directives';

@NgModule({
  declarations: [GroupSearchBarComponent, GroupSearchResultsComponent],
  exports: [GroupSearchBarComponent, GroupSearchResultsComponent],
  imports: [
    FormsModule,
    CommonModule,
    MatIconModule,
    TranslateModule.forChild(),
    RouterModule,
    LoadingModule,
    HighlightPipe,
    ClickedOutsideDirective,
    IconButtonComponent,
    V2ButtonComponent,
    V2TextInputComponent,
    FeatureFlagDirective
  ]
})
export class GroupSearchModule {}
